const apiBase = ((import.meta.env.VITE_API_BASE as string | undefined) ?? '').replace(/\/$/, '');

export function apiUrl(path: string): string {
  return `${apiBase}${path}`;
}

export function wsUrl(path: string): string {
  if (apiBase) {
    return `${apiBase.replace(/^http/, 'ws')}${path}`;
  }
  const proto = location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${location.host}${path}`;
}
